import { render, staticRenderFns } from "./logStatistics.vue?vue&type=template&id=c0be6a56&scoped=true&"
import script from "./logStatistics.vue?vue&type=script&lang=js&"
export * from "./logStatistics.vue?vue&type=script&lang=js&"
import style0 from "./logStatistics.vue?vue&type=style&index=0&id=c0be6a56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0be6a56",
  null
  
)

export default component.exports